<template>
  <v-container class="container">
    <v-card class="mt-5">
      <v-card-text>
        <v-row >
          <v-col cols="3">
            <v-select
              v-model="eleccionSelected"
              :items="elecciones"
              item-value="nombre_corto"
              item-text="nombre_completo"
              label="Elección"
              @change="getPagos()"
              outlined
              dense
              chips
              deletable-chips
            />
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="conceptoSelectedId"
              :items="conceptos"
              item-value="id"
              item-text="name"
              label="Concepto de pago"
              @change="getPagos()"
              outlined
              dense
              chips
              deletable-chips
            />

          </v-col>

          <v-col cols="4">
            <v-text-field
              v-model="search"
              type="text"
              label="Buscar"
              @keyup.enter="getPagos()"

            ></v-text-field>
          </v-col>
          <v-col class="d-flex justify-end" cols="2">
            <v-btn
              color="primary"
              @click="getPagos()"
              class="d-flex justify-end"
            >Consultar estado</v-btn
            >
          </v-col>
        </v-row>

        <v-row>

        </v-row>
        <div class="mb-3 d-flex justify-space-between align-center">
          <v-menu
            v-model="showEstadosInfo"
            bottom
            right
            offset-y
            open-on-hover
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="primary"
                class="info-trigger-btn"
                v-bind="attrs"
                v-on="on"
                aria-label="Ver diagrama de estados"
              >
                <v-icon>mdi-information-outline</v-icon>
              </v-btn>
            </template>
            <v-card class="info-popover-card">
              <v-card-title class="subtitle-2 pb-2">
                Estados pago vocales
              </v-card-title>
              <v-card-text class="pt-0 info-popover-content">
                <img
                  src="/img/estados.png"
                  alt="Diagrama de estados de pago vocales"
                  class="info-popover-image"
                />
                <div class="info-popover-extra mt-3">
                  <ul class="info-list">
                    <li v-for="item in estadosInfoItems" :key="item.estado">
                      <strong>{{ item.estado }}:</strong> {{ item.descripcion }}
                    </li>
                  </ul>
                </div>
              </v-card-text>
            </v-card>
          </v-menu>
          <strong>Total registros: {{ total }}</strong>
        </div>
        <ModalEstadoEgreso
          v-if="showDialog"
          @closeDialog="closeDialog"
          :statusDialog="showDialog"
        />
        <div>
          <v-data-table
            :headers="headers"
            :items="pagos"
            :items-per-page="limit"
            :page="offset"
            :server-items-length="total"
            class="caption"
            disable-sort
            :footer-props="{
              'items-per-page-options': [10, 30, 60, 100]
            }"
            @pagination="onPaginate"
            @update:page="onPageChange"
            @update:items-per-page="onItemsPerPageChange"
          >
            <template v-slot:[`item.nombre`]="{ item }">
              {{ item.nombre }} {{ item.apellidopaterno }}
            </template>
            <template v-slot:[`item.rut`]="{ item }">
              {{ item.rut }}-{{ item.dv }}
            </template>
            <template v-slot:[`item.fechacreacion`]="{ item }">
              {{ formatDate(item.fechacreacion) }}
            </template>
            <template v-slot:[`item.estado`]="{ item }">
              <v-chip
                :color="getChipColor(item.estado)"
                text-color="white"
                small
              >
                {{ item.estado }}
              </v-chip>
            </template>


            <template v-slot:[`item.verDetalle`]="{ item }">
              <div class="d-flex">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="black"
                      style="font-size: 35px"
                      @click="openModal(item.id)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-card-search-outline
                    </v-icon>
                  </template>
                  <span>Ver Detalle</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </div>
        <v-row v-if="this.conceptoSelectedId==='SERVEL_PAGO_VOCAL'&& this.showButtons(10)">
          <v-col class="d-flex justify-end" >
            <v-btn color="success" class="mr-4" @click="marcarCola('CREADO_VALIDO')">Enviar Pago Vocales Masivo</v-btn>
            <v-btn color="warning" @click="marcarCola('REZAGADO_VALIDO')">Enviar Pagos de Vocales Rezagados</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="this.conceptoSelectedId==='SERVEL_PAGO_CAPACITADO' && this.showButtons(10)">
          <v-col class="d-flex justify-end">
            <v-btn color="success" class="mr-4" @click="marcarCola('CREADO_VALIDO')">Enviar Pago Capacitado Masivo</v-btn>
            <v-btn color="warning" @click="marcarCola('REZAGADO_VALIDO')">Enviar Pagos de Capacitados Rezagados</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="this.conceptoSelectedId==='SERVEL_PAGO_ESCRUTADOR' && this.showButtons(10)">
          <v-col class="d-flex justify-end">
            <v-btn color="success" class="mr-4" @click="marcarCola('CREADO_VALIDO')">Enviar Pago Escrutadores Masivo</v-btn>
            <v-btn color="warning" @click="marcarCola('REZAGADO_VALIDO')">Enviar Pagos de Escrutadores Rezagados</v-btn>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>
    <modal-estado-pago
      v-model="dialogoAbierto"
      :pago-id="pagoSeleccionadoId"
      @update:visible="onCloseDialog"
    />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import ModalEstadoPago from "./ModalEstadoPago.vue";
import { PagoVocalesService } from "../../util/Api/PagoVocales/calls";
import { Loading } from "element-ui";
import Swal from "sweetalert2";
import * as XLSX from "xlsx/xlsx.mjs";

export default {
  name: "EstadoEgresoComponents",
  components: {
    ModalEstadoPago,
  },
  data() {
    return {
      status: false,
      showDialog: false,
      elecciones:[],
      eleccionSelected:null,
      total: 0,
      limit: 10, //la cantidad
      offset: 1, //la pagina
      search: null,
      isPagosLoading: false,

      conceptos: [
        {
          id: 'SERVEL_PAGO_VOCAL',
          name: "PAGO A VOCAL",
        },
        {
          id: 'SERVEL_PAGO_CAPACITADO',
          name: "PAGO POR CAPACITACION",
        },{
          id: 'SERVEL_PAGO_ESCRUTADOR',
          name: "PAGO POR ESCRUTADOR",
        },

      ],
      conceptoSelectedId: null,

      headers: [
        { text: "RUT", value: "rut" },
        { text: "NOMBRE", value: "nombre" },
        { text: "NUMERO CUENTA", value: "numerocuentapago" },
        { text: "CODIGO MESA", value: "codigomesa" },
        { text: "FECHA CARGA", value: "fechacreacion" },
        { text: "ESTADO", value: "estado" },
        { text: "VER DETALLE", value: "verDetalle", sortable: false },
      ],
      pagos: [],
      estadosInfoItems: [
        {
          estado: "CREADO_VALIDO",
          descripcion: "Pago ingresado a SERVEL de forma masiva sin errores en la validacion preliminar.",
        },
        {
          estado: "CREADO_CON_ERROR",
          descripcion: "Pago ingresado a SERVEL de forma masiva con errores en la validacion preliminar.",
        },
        {
          estado: "REZAGADO_VALIDO",
          descripcion: "Pago ingresado a SERVEL mediante formulario de rezagados sin errores en la validacion preliminar.",
        },
        {
          estado: "REZAGADO_CON_ERROR",
          descripcion: "Pago ingresado a SERVEL mediante formulario de rezagados con errores en la validacion preliminar.",
        },
        {
          estado: "ENCOLADO",
          descripcion: "Pago en proceso de envio a TGR.",
        },
        {
          estado: "RECIBIDA",
          descripcion: "Orden de pago recibida por TGR.",
        },
        {
          estado: "RECHAZADA",
          descripcion: "Orden rechazada por una validacion posterior a la recepcion (por ejemplo, direccion o cuenta).",
        },
        {
          estado: "ACEPTADA",
          descripcion: "La orden cumple las validaciones de TGR para enviar a banco.",
        },
        {
          estado: "DEPOSITO_ENVIADO",
          descripcion: "Se envia deposito a banco.",
        },
        {
          estado: "DOCUMENTO_ENVIADO",
          descripcion: "No se pudo enviar deposito a banco y se genero pago por caja en BancoEstado.",
        },
        {
          estado: "DEPOSITO_PROCESADO",
          descripcion: "El banco comprobo el deposito.",
        },
      ],

      dialogoAbierto: false,
      pagoSeleccionadoId: null,
      showEstadosInfo: false,
    };
  },

  computed: {
    ...mapGetters(["getPerfil"]),
  },

  mounted() {
    this.getElecciones();
  },

  methods: {

    openModal(id) {
      this.pagoSeleccionadoId = id;
      this.dialogoAbierto = true;
    },
    // opcional: si quieres reaccionar cuando se cierra
    onCloseDialog() {
      this.dialogoAbierto = false;
      this.pagoSeleccionadoId = null;
    },

    showButtons(accesoId){
      // Verificar que getPerfil existe
      if (!this.getPerfil) {
        return false;
      }
      // Verificar que accesos existe y es un array antes de usar some
      return this.getPerfil.accesos && Array.isArray(this.getPerfil.accesos) &&
        this.getPerfil.accesos.some(acceso => acceso.id === accesoId);
    },

    async getElecciones() {
      try {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        });
        this.elecciones = await PagoVocalesService.getElecciones();

        this.loadingInstance.close();
      } catch (error) {
        this.loadingInstance.close();
        console.log("error", error);
        Swal.fire({
          type: "error",
          html: `Error al cargar la lista de elecciones: ${error}`,
        });
      }
    },
    async getPagos() {
      if (this.isPagosLoading) {
        return;
      }
      try {
        this.isPagosLoading = true;
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        });

        const params = {
          limit: this.limit !== -1 ? this.limit : this.total, //la cantidad
          page: this.offset,
          nombreeleccion: this.eleccionSelected ? this.eleccionSelected : null ,
          search: this.search ? this.search : null,
          conceptopago: this.conceptoSelectedId ? this.conceptoSelectedId : null,
        };

        this.pagos = await PagoVocalesService.getAll(params);

        this.pagos.length ? (this.total = Number(this.pagos[0].total)) : null;
        this.loadingInstance.close();
      } catch (error) {
        this.loadingInstance.close();
        console.log("error", error);
        Swal.fire({
          type: "error",
          html: `Error al cargar los Pagos: ${error}`,
        });
      } finally {
        this.isPagosLoading = false;
      }
    },

    onPaginate({ page, itemsPerPage }) {
      const pageChanged = page !== this.offset;
      const perPageChanged = itemsPerPage !== this.limit;
      this.offset = page;
      this.limit = itemsPerPage;
      if (pageChanged || perPageChanged) {
        this.getPagos();
      }
    },

    async marcarCola(estado) {
      try {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        });

        const params = {
          idusuario: this.getPerfil.idusuario,
          data: {
            estadoActual: estado,
            conceptoPago: this.conceptoSelectedId,
            }

        };

       await PagoVocalesService.marcarCola(params);

        Swal.fire({
          type: "success",
          html: `Pagos encolados Correctamente`,
        });

        await this.getPagos()

        this.loadingInstance.close();
        
      } catch (error) {
        this.loadingInstance.close();
        console.log("error", error);
        Swal.fire({
          type: "error",
          html: `Error al enviar a la cola: ${error}`,
        });
      }
    },

    async descargarExcel() {
      let name = "Pagos";
      if (this.getPerfil && this.getPerfil.subdireccion_id) {
        name += `-Sub${this.getPerfil.subdireccion_id}`;
      }
      if (this.fechaEleccion) {
        name += `-${this.fechaEleccion}`;
      }
      name = `${name}.xlsx`;

      const ws = XLSX.utils.json_to_sheet(this.pagos);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Pagos");

      XLSX.writeFile(wb, name);
    },

    getChipColor(estado) {
      const estadosVerdes = ['CREADO_VALIDO', 'EDITADO_VALIDO', 'ENCOLADO', 'ENVIADO'];
      const estadosRojos = ['CREADO_CON_ERROR', 'EDITADO_CON_ERROR', 'FALLO_ENCOLAR', 'FALLO_ENVIAR'];

      if (estadosVerdes.includes(estado)) {
        return 'success';
      } else if (estadosRojos.includes(estado)) {
        return 'error';
      } else {
        return 'primary'; // Azul por defecto
      }
    },
    formatDate(dateString) {
      if (!dateString) return "";
      const d = new Date(dateString);
      const year = d.getFullYear();
      const month = (`0${d.getMonth() + 1}`).slice( -2);
      const day = (`0${d.getDate()}`).slice( -2);
      return `${day}-${month}-${year}`; 
    },
  },
};
</script>

<style scoped>
.container {
  text-align: start !important;
}

.info-trigger-btn {
  margin-left: -8px;
}

.info-popover-card {
  max-width: 700px;
}

.info-popover-content {
  max-height: 70vh;
  overflow-y: auto;
}

.info-popover-image {
  width: 100%;
  max-width: 660px;
  height: auto;
  display: block;
}

.info-popover-extra {
  font-size: 0.875rem;
}

.info-list {
  margin: 0;
  padding-left: 18px;
  line-height: 1.4;
}

.info-list li {
  margin-bottom: 6px;
}
</style>

